export class LocationService {
    constructor() {
        this.categories = ['Postal', 'Populated Place', 'Land Features', 'Residential Area', 'Airport', 'Water Features'];
        this.suggestUrl = `${process.env.ARC_GIS_URL}/arcgis/rest/services/World/GeocodeServer/suggest?`;
        this.searchUrl = `${process.env.SEARCH_URL}/v2/geo`;
    }
    async getSuggestions(text) {
        const params = new URLSearchParams({
            f: 'json',
            maxSuggestions: '5',
            category: this.categories.join(','),
            text: text,
        });
        return fetch(this.suggestUrl + `${params}`)
            .then(resp => {
            if (!resp.ok) {
                throw new Error(resp.statusText);
            }
            return resp.json().then(data => data.suggestions);
        });
    }
    async getShape(esriMagicKey) {
        let params = new URLSearchParams({
            esriMagicKey: esriMagicKey
        });
        let res;
        // TODO: Explicitly tell fetch to cache results
        await fetch(this.searchUrl + `?${params}`)
            .then(resp => resp.json())
            .then((json) => {
            res = json.results[0];
        })
            .catch(err => {
            console.error(err);
        });
        return res;
    }
    updateShapeBbox(geoJson) {
        let bbox = [-90, 180, 90, -180];
        geoJson.forEach(ring => {
            ring.forEach(point => {
                if (point[1] > bbox[0]) {
                    bbox[0] = point[1];
                }
                if (point[1] < bbox[2]) {
                    bbox[2] = point[1];
                }
                if (point[0] < bbox[1]) {
                    bbox[1] = point[0];
                }
                if (point[0] > bbox[3]) {
                    bbox[3] = point[0];
                }
            });
        });
        return bbox.map(point => point.toFixed(3));
    }
}
const locationService = new LocationService();
export default locationService;
